import React, { FC } from 'react'
import { useAnalytics } from 'reactfire'

import { PieNoShadowIcon } from '../Icons'
import { ModalHeader, ModalText } from '../Typography'
// import { ModalButton } from '../ModalButton'
// import { color } from '../../styles'
import { Modal } from '../Modal'

import { Wrap } from './styled'

import { analyticsEvents } from 'src/constants/analytics/events'

type Props = {
  setOpenWTF: (isOpen: boolean) => void
  openWTF: boolean
}

export const WTFIsPumpkinPie: FC<Props> = ({ setOpenWTF, openWTF }) => {
  const { logEvent } = useAnalytics()

  React.useEffect(() => {
    if (openWTF) {
      logEvent(analyticsEvents.WTFIsDisplayed)
    }
  }, [logEvent, openWTF])

  // const handleLearnMoreClick = () => {
  //   logEvent(analyticsEvents.WTFIsAction)
  // }

  return (
    <Modal isOpen={openWTF} onClose={() => setOpenWTF(false)}>
      <Wrap>
        <PieNoShadowIcon />
        <ModalHeader>WTF is Pumpkin Pie?</ModalHeader>
        <ModalText>
          Pumpkin Pie helps you find people who are like you. In fact, it helps
          you find the person on the planet who is MOST like you! Answer 20
          questions and we will match you with that person. After that, start up
          a conversation and… who knows.
          <br />
          <br />
          Pumpkin Pie is free, private, and not here to make YOU the product.
        </ModalText>
        {/* <ModalButton
          color={color.DULL_ORANGE}
          label="Learn more"
          wtfispp
          onClick={handleLearnMoreClick}
        /> */}
      </Wrap>
    </Modal>
  )
}
